import { Hero } from "app/components/hero";
import { Stack, Button, Icon, Flex } from "@chakra-ui/react";
import AnsibleBanner from "public/services/ansible.webp";
import Link from "next/link";
import { GoArrowRight } from "@onemind-services-llc/react-icons-ng/go";

const HeroSection = () => {
  return (
    <Hero
      title={"Future of Network DevOps Tools: Ansible Instant Environment"}
      image={AnsibleBanner}
      description={[
        "CloudMyLab introduces Ansible Instant Env—your gateway to efficient, automated network management. Within minutes, gain access to a powerful, cloud-hosted environment equipped with pre-built playbooks, modules, and templates tailored for network infrastructure as code. No complex installations, no hardware constraints—just straightforward automation solutions designed to fit your unique needs. Start your automation journey with CloudMyLab and transform the way you manage networks with our cutting-edge NetDevOps tools.",
      ]}
    >
      <Stack direction={{ base: "column", md: "row" }} spacing={5}>
        <Button
          bg={"#007FFF"}
          borderColor="#007FFF"
          borderWidth={"1px"}
          color={"white"}
          fontSize={"lg"}
          _hover={{ backgroundColor: "#0056B3" }}
          as={"a"}
          href={"#contact-form"}
          minW={"200px"}
          minH={"50px"}
        >
          Schedule A Demo
        </Button>
        <Flex
          alignItems={"center"}
          _hover={{ textDecoration: "underline" }}
          justifyContent={"center"}
        >
          <Link
            href={"https://online.flippingbook.com/view/273756176/"}
            style={{
              color: "#007FFF",
              fontSize: "20px",
              fontWeight: "600",
              paddingLeft: "6px",
              paddingRight: "6px",
              alignItems: "center",
            }}
            target="_blank"
          >
            Solution Document
            <Icon as={GoArrowRight} ml={2} style={{ verticalAlign: "middle" }} />
          </Link>
        </Flex>
      </Stack>
    </Hero>
  );
};

export default HeroSection;
